global.Swal = require('sweetalert2/dist/sweetalert2.js');